import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E85F4170-11D3-4757-8247-17EBD07A08D4
 * name unfold-more-horizontal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unfold-more-horizontal.svg
 * tags
 */
export const UnfoldMoreHorizontalIcon = createSvgIcon(<><path d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" /></>, 'UnfoldMoreHorizontalIcon');
export default UnfoldMoreHorizontalIcon